import { createFileRoute } from '@tanstack/react-router';
import { useAuth } from '@/lib/auth/hooks/useAuth';
import useTeams from '@/lib/teams/hooks/useTeams';
import { useMemo } from 'react';

import LoadingCard from '@/lib/loading/components/LoadingCard';
import { StrokesGainedCompareProvider } from '@/lib/strokesGained/hooks/useStrokesGainedCompare';
import { DashboardFilterProvider } from '@/lib/common/hooks/useDashboardFilter';
import PlayerDashboard from '@/components/dashboard/PlayerDashboard';
import TeamDashboard from '@/components/dashboard/TeamDashboard';

export const Route = createFileRoute('/dashboard')({
    component: RouteComponent,
});

function RouteComponent() {
    const { user, userLoaded } = useAuth();
    const { teams, isLoading } = useTeams();

    const noTeams = useMemo(() => teams.length === 0, [teams.length]);

    if (!user || !userLoaded || isLoading) {
        return (
            <div className='mx-auto p-2 md:max-w-7xl'>
                <LoadingCard height='h-96' />
            </div>
        );
    }

    return (
        <div className='mx-2 my-2 px-2 md:mx-auto md:max-w-7xl'>
            <DashboardFilterProvider>
                {noTeams ? (
                    <div className='simple-card'>
                        <PlayerDashboard player={user} />
                    </div>
                ) : (
                    <StrokesGainedCompareProvider teams={teams}>
                        <TeamDashboard teams={teams} />
                    </StrokesGainedCompareProvider>
                )}
            </DashboardFilterProvider>
        </div>
    );
}
